import { useMemo } from 'react';
import { parseNoticeText } from './Utils/parseNoticeText';

export default function NoticeBannerContent({ text }: { text: string }) {
	const parsedSegments = useMemo(() => {
		return parseNoticeText(text);
	}, [text]);

	return (
		<>
			{parsedSegments.map(segment => {
				if (segment.tag === 'b') return <strong key={segment.id}>{segment.text}</strong>;
				if (segment.tag === 'i') return <em key={segment.id}>{segment.text}</em>;
				if (segment.tag === 'u') return <u key={segment.id}>{segment.text}</u>;

				if (segment.tag === 'a') {
					return (
						<a key={segment.id} href={segment.href} target="_blank" rel="noopener noreferrer">
							{segment.text}
						</a>
					);
				}

				return <span key={segment.id}>{segment.text}</span>;
			})}
		</>
	);
}
